import React from 'react';
import { styled } from '@mui/system';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import Chip from 'components/Chip';
import {
  getButtonBackgroundHoverColor,
  getButtonFontHoverColor
} from 'styles/helpers/getThemeStyles';

const PromotionUnlockedChipStyled = styled(Chip, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme }) => {
  return {
    '&.MuiChip-root': {
      backgroundColor: getButtonBackgroundHoverColor(theme),
      height: 'unset',
      borderRadius: '4px'
    },
    '& .MuiChip-label': {
      ...theme.typography.header,
      color: getButtonFontHoverColor(theme),
      padding: '1px 5px 0',
      fontSize: '12px'
    }
  };
});

const PromotionUnlockedChip = () => {
  return (
    <PromotionUnlockedChipStyled
      data-testid="unlocked-chip"
      label="UNLOCKED!"
      ownState={{
        label: { padding: '0 5px 0 5px' },
        root: { borderRadius: '4px' }
      }}
    />
  );
};

export default PromotionUnlockedChip;
